export default __webpack_public_path__ + "static/media/gaikuang.78431945.png";